import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import EditIcon from '@material-ui/icons/Edit'
import RefreshIcon from '@material-ui/icons/Refresh'
import ReplayIcon from '@material-ui/icons/Replay'
import SubjectIcon from '@material-ui/icons/Subject'
import Visibility from '@material-ui/icons/Visibility'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { contentVectorizationActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import Chip from '@material-ui/core/Chip'
import { findPermission } from '../../utils/permissions'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import { TIPOS_CONTEUDO, TIPOS_CONTEUDO_LABELS } from './AddModal'
import { STATUS_CONFIG, isFailed } from '../../constants/vectorization'
import { ContentHtml } from 'informed-shared/components/es/Content'

class ListTable extends Component {
  state = {
    debounce: undefined,
    loadingStatus: false,
    viewItem: null,
    previewItem: null,
  }

  componentDidMount() {
    this.fetchData()
  }

  componentDidUpdate(prevProps) {
    const { loadingConteudos } = this.props

    if (loadingConteudos) return

    const oldPagination = prevProps.pagination || {}

    const shouldReload =
      this.props.pagination.page !== oldPagination.page ||
      this.props.pagination.rowsPerPage !== oldPagination.rowsPerPage ||
      this.props.tipoFilter !== prevProps.tipoFilter

    if (shouldReload) {
      const debounce = setTimeout(() => {
        this.fetchData()
      }, 400)

      this.setState((state) => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
  }

  fetchData = (props) => {
    const { fetchConteudos, pagination, tipoFilter } = props || this.props
    fetchConteudos({
      page: pagination.page,
      perPage: pagination.rowsPerPage,
      tipo: tipoFilter,
    })
  }

  renderStatus = (status) => {
    const config = STATUS_CONFIG[status] || { label: status || 'Desconhecido', color: 'default' }
    return <Chip label={config.label} color={config.color} size="small" />
  }

  getContentHtml = (item) => {
    return item.conteudoHtml || item.documento || item.document || item.html || ''
  }

  renderEllipsis = (value, title) => (
    <div
      title={title || value}
      style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
    >
      {value || '--'}
    </div>
  )

  normalizeConteudoForModal = (item) => ({
    tipo: item.tipo || '',
    titulo: item.titulo || '',
    content_id: item.content_id || '',
    autores: item.autores || [],
    ano: item.ano || null,
    especialidade: item.especialidade || '',
    isbn: item.isbn || null,
    conteudoHtml: this.getContentHtml(item),
    idVetor: item.idVetor || item.id_vetor || null,
  })

  handleVerStatus = (item) => {
    const { fetchConteudoStatus, changeMessage } = this.props
    this.setState({ loadingStatus: true })

    fetchConteudoStatus(item.content_id)
      .then((data) => {
        this.setState({ loadingStatus: false })
        const status = data.status || data.status_atual || 'desconhecido'
        const msg = `Status de "${item.titulo}": ${status}`
        changeMessage({ message: msg })
      })
      .catch(() => {
        this.setState({ loadingStatus: false })
        changeMessage({ message: 'Erro ao buscar status do conteúdo.' })
      })
  }

  handleEditarParaVetorizar = (item) => {
    const { newFormConteudo, handleChangeConteudo, openModal } = this.props
    newFormConteudo()
    handleChangeConteudo(this.normalizeConteudoForModal(item))
    openModal()
  }

  handleReprocessar = (item) => {
    const { reprocessarConteudo, changeMessage, fetchConteudos, pagination, tipoFilter } =
      this.props

    reprocessarConteudo(item.content_id)
      .then(() => {
        changeMessage({ message: `Conteúdo "${item.titulo}" enviado para reprocessamento.` })
        fetchConteudos({ page: pagination.page, perPage: pagination.rowsPerPage, tipo: tipoFilter })
      })
      .catch((err) => {
        const msg = ((err.response || {}).data || {}).message || 'Erro ao reprocessar conteúdo.'
        changeMessage({ message: msg })
      })
  }

  renderActions = (item) => {
    const { deleteConteudo, addConfirm, changeMessage, token } = this.props

    const status = item.status || ''
    const itemFailed = isFailed(status)

    return (
      <Fragment>
        {/* Visualizar */}
        <IconButton
          onClick={() => this.setState({ viewItem: item })}
          aria-label="Visualizar"
          title="Visualizar"
        >
          <Visibility nativeColor="rgba(0,0,0,0.87)" />
        </IconButton>

        {/* Ver conteúdo vetorizado */}
        <IconButton
          onClick={() => this.setState({ previewItem: item })}
          aria-label="Ver conteúdo vetorizado"
          title="Ver conteúdo vetorizado"
        >
          <SubjectIcon nativeColor="rgba(0,0,0,0.54)" />
        </IconButton>

        {/* Editar e vetorizar novamente */}
        <IconButton
          onClick={() => this.handleEditarParaVetorizar(item)}
          aria-label="Editar para vetorizar novamente"
          title="Editar para vetorizar novamente"
        >
          <EditIcon nativeColor="rgba(0,0,0,0.54)" />
        </IconButton>

        {/* Ver Status */}
        <IconButton
          onClick={() => this.handleVerStatus(item)}
          aria-label="Ver Status"
          title="Ver status do conteúdo"
        >
          <RefreshIcon nativeColor="rgba(0,0,0,0.54)" />
        </IconButton>

        {/* Reprocessar (só para falhos) */}
        {itemFailed && (
          <IconButton
            onClick={() => this.handleReprocessar(item)}
            aria-label="Reprocessar"
            title="Reprocessar conteúdo"
          >
            <ReplayIcon nativeColor="rgba(0,0,0,0.54)" />
          </IconButton>
        )}

        {/* Deletar */}
        {findPermission('vetorizacaoConteudos', token).remover && (
          <IconButton
            onClick={() => {
              addConfirm({
                confirmMessage: `Confirma a exclusão do conteúdo "${item.titulo}"?`,
                confirmFunction: () => {
                  return deleteConteudo(item.content_id)
                    .then(() => {
                      changeMessage({ message: 'Conteúdo excluído com sucesso.' })
                    })
                    .catch((err) => {
                      const msg =
                        ((err.response || {}).data || {}).message || 'Erro ao excluir conteúdo.'
                      changeMessage({ message: msg })
                    })
                },
              })
            }}
            aria-label="Deletar"
          >
            <ActionDelete />
          </IconButton>
        )}
      </Fragment>
    )
  }

  renderDetailsDialog = () => {
    const { viewItem } = this.state
    if (!viewItem) return null

    const rows = [
      ['Título', viewItem.titulo],
      ['Tipo', TIPOS_CONTEUDO_LABELS[viewItem.tipo] || viewItem.tipo],
      ['Content ID', viewItem.content_id],
      ['Especialidade', viewItem.especialidade],
      ['Ano', viewItem.ano],
      ['Status', viewItem.status],
      ['ID Vetor', viewItem.idVetor || viewItem.id_vetor],
    ]

    return (
      <Dialog
        modalId="vetorizacao-conteudos-visualizar"
        modalParams={{ content_id: viewItem.content_id }}
        fullWidth
        maxWidth="md"
        open
        onClose={() => this.setState({ viewItem: null })}
      >
        <DialogTitle id="vetorizacao-conteudos-visualizar-title">
          Vetorização de conteúdos — Visualizar
        </DialogTitle>
        <DialogContent>
          {rows.map(([label, value]) => (
            <div key={label} style={{ marginBottom: 12 }}>
              <Typography variant="caption" color="textSecondary">
                {label}
              </Typography>
              <Typography variant="body1">{value || '--'}</Typography>
            </div>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ viewItem: null })} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  renderPreviewDialog = () => {
    const { previewItem } = this.state
    if (!previewItem) return null

    const contentHtml = this.getContentHtml(previewItem)

    return (
      <Dialog
        modalId="vetorizacao-conteudos-preview-vetorizado"
        modalParams={{ content_id: previewItem.content_id }}
        fullWidth
        maxWidth="lg"
        open
        onClose={() => this.setState({ previewItem: null })}
      >
        <DialogTitle id="vetorizacao-conteudos-preview-vetorizado-title">
          Conteúdo vetorizado
        </DialogTitle>
        <DialogContent>
          {contentHtml ? (
            <div className="ContentPreview ContentPreview-min-600 ContentPreview-hide-unknown-markers InformedContentStyle VectorizationContentPreview">
              <ContentHtml
                content={this.normalizeConteudoForModal(previewItem)}
                contentPreview={contentHtml}
              />
            </div>
          ) : (
            <Typography color="textSecondary">
              A listagem não retornou o HTML completo deste conteúdo.
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.handleEditarParaVetorizar(previewItem)
              this.setState({ previewItem: null })
            }}
            color="primary"
          >
            Editar para vetorizar novamente
          </Button>
          <Button onClick={() => this.setState({ previewItem: null })} color="default">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  handleChangePage = (event, page) => {
    this.props.handleChangePage(page)
  }

  handleChangeRowsPerPage = (event) => {
    this.props.handleChangePerPage(event.target.value)
  }

  render() {
    const {
      classes,
      conteudos = [],
      loadingConteudos,
      pagination,
      tipoFilter,
      changeTipoFilter,
    } = this.props

    return (
      <Paper className={classes.wrapperTable + ' VectorizationTableWrapper'} elevation={4}>
        {/* Filtro por tipo */}
        <div style={{ padding: '8px 16px', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Typography variant="body2" style={{ color: 'rgba(0,0,0,0.54)' }}>
            Filtrar por tipo:
          </Typography>
          <FormControl style={{ minWidth: 160 }}>
            <Select
              value={tipoFilter || ''}
              onChange={(e) => changeTipoFilter(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">Todos</MenuItem>
              {TIPOS_CONTEUDO.map((tipo) => (
                <MenuItem key={tipo} value={tipo}>
                  {TIPOS_CONTEUDO_LABELS[tipo] || tipo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* Loader */}
        {!!loadingConteudos && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}

        <Table
          className="VectorizationResponsiveTable"
          fixedHeader
          width="990px"
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)',
          }}
        >
          <TableHeader displaySelectAll={false} className={classes.tableHeader} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn>Título</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '110px' }}>Tipo</TableHeaderColumn>
              <TableHeaderColumn>Content ID</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Especialidade</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '60px' }}>Ano</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '120px' }}>Status</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '130px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(conteudos || []).length ? (
              conteudos.map((item, idx) => (
                  <TableRow key={item.content_id || idx}>
                    <TableRowColumn data-label="Título">
                      {this.renderEllipsis(item.titulo, item.titulo)}
                    </TableRowColumn>
                    <TableRowColumn data-label="Tipo" style={{ width: '110px' }}>
                      {TIPOS_CONTEUDO_LABELS[item.tipo] || item.tipo || '--'}
                    </TableRowColumn>
                    <TableRowColumn data-label="Content ID">
                      {this.renderEllipsis(item.content_id, item.content_id)}
                    </TableRowColumn>
                    <TableRowColumn data-label="Especialidade" style={{ width: '100px' }}>
                      {this.renderEllipsis(item.especialidade, item.especialidade)}
                    </TableRowColumn>
                    <TableRowColumn data-label="Ano" style={{ width: '60px' }}>
                      {item.ano || '--'}
                    </TableRowColumn>
                    <TableRowColumn data-label="Status" style={{ width: '120px' }}>
                      {this.renderStatus(item.status)}
                    </TableRowColumn>
                    <TableRowColumn
                      data-label="Ações"
                      className="VectorizationResponsiveActions"
                      style={{ width: '210px' }}
                    >
                      {this.renderActions(item)}
                    </TableRowColumn>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {loadingConteudos ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>

        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count }) =>
              `Exibindo de ${from} a ${to} de ${count}`
            }
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[20, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{ 'aria-label': 'Página anterior' }}
            nextIconButtonProps={{ 'aria-label': 'Próxima página' }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
        {this.renderDetailsDialog()}
        {this.renderPreviewDialog()}
      </Paper>
    )
  }
}

const mapStateToProps = (state) => ({
  conteudos: state.contentVectorization.conteudos,
  loadingConteudos: state.contentVectorization.loadingConteudos,
  pagination: state.contentVectorization.pagination,
  tipoFilter: state.contentVectorization.tipoFilter,
  token: state.auth.token,
})

const mapDispatchToProps = (dispatch) => ({
  fetchConteudos: (options) => dispatch(contentVectorizationActions.fetchConteudos(options)),
  deleteConteudo: (contentId) => dispatch(contentVectorizationActions.deleteConteudo(contentId)),
  handleChangePage: (page) => dispatch(contentVectorizationActions.handleChangePage(page)),
  handleChangePerPage: (perPage) => dispatch(contentVectorizationActions.handleChangePerPage(perPage)),
  changeTipoFilter: (tipo) => dispatch(contentVectorizationActions.changeTipoFilter(tipo)),
  newFormConteudo: () => dispatch(contentVectorizationActions.newFormConteudo()),
  handleChangeConteudo: (conteudo) =>
    dispatch(contentVectorizationActions.handleChangeConteudo(conteudo)),
  openModal: () => dispatch(contentVectorizationActions.openModal()),
  fetchConteudoStatus: (contentId) =>
    dispatch(contentVectorizationActions.fetchConteudoStatus(contentId)),
  reprocessarConteudo: (contentId) =>
    dispatch(contentVectorizationActions.reprocessarConteudo(contentId)),
  addConfirm: ({ confirmMessage, confirmFunction }) =>
    dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction })),
  changeMessage: ({ message }) => dispatch(messageActions.changeMessage({ message })),
})

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/ContentVectorization/ListTable.js